import './QuoteDetailNoticeSkeleton.scss';

/** Skeleton de carga para el aviso informativo de la cotización */
const QuoteDetailNoticeSkeleton = () => {
  return (
    <div className="quoteDetailNoticeSkeleton">
      <div className="iconSkeleton animationLoader" />
      <div className="textSkeleton animationLoader" />
    </div>
  );
};

export default QuoteDetailNoticeSkeleton;
